export default __webpack_public_path__ + "static/media/logo_intheblack_placeholder.1f0806b8.svg";